"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
DistanceFilter.$inject = [];
function DistanceFilter() {
    return function (distance) {
        return distance / 1000; //from m to km
    };
}
exports.DistanceFilter = DistanceFilter;
;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/filters/DistanceFilter.js
// module id = 601
// module chunks = 0